/* eslint-disable react/jsx-props-no-spreading */
import React from 'react';
import { Redirect, Route } from 'react-router-dom';
import { createPath, ROUTE } from 'utils/Routing';

const ProtectedRoute = ({ isAuth, component: Component, ...rest }: any) => {
  return (
    <Route
      {...rest}
      render={({ location }) => {
        return isAuth === true ? (
          <Component />
        ) : (
          <Redirect
            to={{
              pathname: createPath({ path: ROUTE.LOGIN }),
              state: { from: location },
            }}
          />
        );
      }}
    />
  );
};

export default ProtectedRoute;
